<template>
  <div>
    <el-card shadow="always">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <el-input size="small" style="width: 250px" placeholder="搜索名称关键字" clearable v-model.trim="params.keyword" @change="getData()">
            <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
          </el-input>
          <el-button size="mini" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
        </div>
        <el-button size="mini" type="primary" @click="saveDialog()" v-if="$isPerm('customer-tag-save')">添加标签</el-button>
      </div>
    </el-card>
    <el-table height="600" size="small" :data="list" border row-key="id" @selection-change="handleSelectionChange" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="name" label="标签" width="100"></el-table-column>
      <el-table-column prop="customer_qty" label="客户数" width="100"></el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="saveDialog(scope.row)" v-if="$isPerm('customer-tag-save')">编辑</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)" v-if="$isPerm('customer-tag-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="saveDialogTitle" :visible.sync="saveDialogShow" width="300px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <el-form size="small" ref="formRef" :model="formData" :rules="rules" label-width="60px" style="padding: 20px">
        <el-form-item label="标签" prop="name" :error="errMsg.name">
          <el-input v-model="formData.name" style="width: 180px"></el-input>
        </el-form-item>
      </el-form>
      <div class="form-but">
        <el-button size="small" type="primary" :loading="loading" @click="saveData()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'customerTag',
  components: {},
  created() {
    this.getData();
  },
  data() {
    return {
      saveDialogTitle: '',
      saveDialogShow: false,
      loading: false,
      list: [],
      params: {
        keyword: ''
      },
      formData: {
        id: 0,
        name: ''
      },
      rules: {
        name: [{ required: true, message: '请输入标签', trigger: 'blur' }]
      },
      errMsg: {},
      selectedIds: []
    };
  },
  methods: {
    //新增/编辑
    saveDialog(row) {
      this.saveDialogShow = true;
      this.saveDialogTitle = '添加客户标签';
      this.formData = {
        id: 0,
        name: ''
      };
      if (row) {
        this.saveDialogTitle = '编辑客户标签';
        this.formData = _.cloneDeep(row);
      }
    },
    // 保存数据
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (!vaild) return;
        this.setEmptyErrMsg();
        this.loading = true;
        let data = _.cloneDeep(this.formData);
        await this.$api.customerTag.save(data).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.saveDialogShow = false;
            this.getData();
          }
        });
      });
    },
    //初始化错误信息对象
    setEmptyErrMsg() {
      this.errMsg = {};
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '');
      });
    },
    //删除
    async deleteData(id) {
      if (this.selectedIds.length == 0 && !id) {
        this.$message.warning('未选中数据');
        return;
      }
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let params = {
            ids: this.selectedIds.join(',')
          };
          if (id) {
            params.ids = id;
          }
          this.loading = true;
          await this.$api.customerTag.delete(params).then(res => {
            this.loading = false;
            if (res.code != 200) return;
            this.$message.success(res.msg);
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 获取数据
    async getData() {
      let params = Object.assign({}, this.params);
      await this.$api.customerTag.list(params).then(res => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
    //多选
    handleSelectionChange(selectedItems) {
      let list = [];
      for (const val of selectedItems) {
        if (!list.includes(val.id)) {
          list.push(val.id);
        }
      }
      this.selectedIds = list;
    },
    //刷新
    refresh() {
      this.getData();
    }
  }
};
</script>
